<template>
  <div class="oprationing global_pointer">
    <img :src="data.icon" alt="" />
    <span>{{ data.name}}</span>
  </div>
</template>
<script>
export default {
  name: 'oprationing',
  props: ['data'],
  methods: {
  },
};
</script>
<style lang="less" scoped>
.oprationing {
  margin-right: 4px;
  padding: 8px;
  background: #1d1d1d;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #1d1d1d;
  &.selected {
    border: 1px solid #39d2d6;
  }
  & img {
    width: 28px;
    height: 28px;
    margin-right: 8px;
    border-radius: 14px;
  }
  & span {
    display: inline-block;
    height: 18px;
    font-size: 13px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: #ffffff;
    line-height: 18px;
    word-break:keep-all;
    white-space: nowrap;
  }
}
</style>
